import { api } from '@/services/api/main/axios';

export const getTagsApiRequest = async (
  params: Record<string, unknown> = {},
): Promise<unknown[]> => {
  const res = await api.get<{ payload: unknown[] }>('tags', { params });
  return res.data.payload;
};
